import { faBadgeCheck } from "@jewlr/pro-light-svg-icons/faBadgeCheck"
import { faHandHoldingCircleDollar } from "@jewlr/pro-light-svg-icons/faHandHoldingCircleDollar"
import { faBox } from "@jewlr/sharp-light-svg-icons/faBox"
import PropTypes from "prop-types"
import { Link } from "react-router-dom"

// import { openModal } from "components/modal"
import Button from "components/ui/button"
import FontAwesomeIcon from "components/ui/font-awesome-icon"
import Image from "components/ui/image"
import Picture from "components/ui/picture"
import { jewlr_t, IS_NA } from "helpers/application"

const CodeRef = ({ text }) => {
  if (text.text === "homepage-last-chance") {
    return (
      <div className="desktop:flex mb-20 hidden items-center gap-24 font-semibold text-white">
        <p className="h2 font-semibold">
          Hurry! Meaningful gifts still <br />
          available for on-time arrival.
        </p>
        <Image
          alt=""
          className="w-(--base-width) widescreen:w-(--widescreen-width) aspect-(--base-aspect-ratio)"
          height="72"
          src={require("images/layout/d-truck.svg")}
          style={{
            "--base-aspect-ratio": "122 / 72",
            "--base-width": "80px",
            "--widescreen-width": "120px",
          }}
          width="122"
        />
      </div>
    )
  } else if (text.text === "jewlr-gg-hero-heading") {
    return (
      <h1 className="desktop:w-3/5 large:w-3/4 mb-4 w-3/4">
        <Picture
          alt={`The Perfect Gift Is ${IS_NA() ? "Personal(ized)" : "Personal(ised)"}`}
          className="max-w-660"
          fallback={require(
            `images/layout/${IS_NA() ? "d-tt-the-perfect-gift-us-ca.svg" : "d-tt-the-perfect-gift-au-uk.svg"}`
          )}
          lazyload={false}
          srcSet={[
            {
              height: 85,
              media: "(max-width: 1023px)",
              srcSet: require(
                `images/layout/${IS_NA() ? "m-tt-the-perfect-gift-us-ca.svg" : "m-tt-the-perfect-gift-au-uk.svg"}`
              ),
              width: 302,
            },
            {
              height: 142,
              media: "(min-width: 1024px)",
              srcSet: require(
                `images/layout/${IS_NA() ? "d-tt-the-perfect-gift-us-ca.svg" : "d-tt-the-perfect-gift-au-uk.svg"}`
              ),
              width: 509,
            },
          ]}
        />
      </h1>
    )
  } else if (text.text === "jewlr-gg-hero-heading-v2") {
    return (
      <h1 className="desktop:w-3/5 large:w-3/4 mb-4">
        <Picture
          alt={"Made with Love, Meant to Last"}
          className="max-w-370 desktop:max-w-660"
          fallback={require("images/layout/d-made-with-love-meant-to-last.svg")}
          lazyload={false}
          srcSet={[
            {
              height: 23,
              media: "(max-width: 1023px)",
              srcSet: require("images/layout/m-made-with-love-meant-to-last.svg"),
              width: 335,
            },
            {
              height: 160,
              media: "(min-width: 1024px)",
              srcSet: require("images/layout/d-made-with-love-meant-to-last.svg"),
              width: 660,
            },
          ]}
        />
      </h1>
    )
  } else if (text.text === "jewlr-gg-hero-value-props") {
    return (
      <div className="my-24 flex flex-col gap-16">
        <div className="desktop:text-left large:gap-40 desktop:gap-32 flex items-center justify-between gap-40 text-center">
          <div className="desktop:flex-row flex flex-col items-center justify-center gap-8">
            <FontAwesomeIcon
              className="text-28 desktop:text-24"
              icon={faBadgeCheck}
            />
            <h2 className="body-sm font-semibold">
              2M+ Happy <br className="desktop:hidden" />
              Customers
            </h2>
          </div>
          <div className="desktop:flex-row flex flex-col items-center justify-center gap-8">
            <FontAwesomeIcon
              className="text-28 desktop:text-24"
              icon={faHandHoldingCircleDollar}
            />
            <h2 className="body-sm font-semibold">
              Buy Now<span className="desktop:inline hidden">,</span>{" "}
              <br className="desktop:hidden" />
              Pay Layer
            </h2>
          </div>
          <div className="desktop:flex-row flex flex-col items-center justify-center gap-8">
            <FontAwesomeIcon className="text-28 desktop:text-24" icon={faBox} />
            <h2 className="body-sm font-semibold">
              Free <br className="desktop:hidden" />
              {jewlr_t("terms.Shipping")}
            </h2>
          </div>
        </div>
      </div>
    )
  } else if (text.text === "jewlr-gg-cta-row") {
    return (
      <div className="tablet:gap-24 desktop:w-auto flex w-full items-center justify-center gap-16">
        <Button
          asChild
          className="tablet:max-w-320 desktop:max-w-220 flex-1 uppercase"
          variant="secondary"
        >
          <Link
            data-lc="jewlr-gift-guide-hero"
            to={`/holiday-${jewlr_t("terms.jewelry")}-sale-collection`}
          >
            Shop Sale
          </Link>
        </Button>
        <Button
          asChild
          className="tablet:max-w-320 desktop:max-w-220 border-black-print desktop:text-black-print flex-1 border uppercase"
          variant="tertiary"
        >
          <Link data-lc="jewlr-gift-guide-hero" to="/holiday-gift-guide">
            Gift Guide
          </Link>
        </Button>
      </div>
    )
  }

  // if (text.text === "BESTSALE") {
  //   return sl.config.sale_key.includes("cyber-monday") ? (
  //     <div className="xlarge:flex-row xlarge:gap-24 flex w-full flex-col items-center justify-center gap-10">
  //       <Image
  //         alt="+ Extra 20%*"
  //         className="large:w-3/4 desktop:w-3/5 tablet:w-9/10 max-w-256 w-3/5"
  //         height="43"
  //         lazyload={false}
  //         src={require("images/layout/extra-20-off.svg")}
  //         width="256"
  //       />
  //       <div className="text-black-print desktop:text-18 tablet:text-28 text-18 mobile:text-20 large:px-32 large:py-16 border-black-print border-2 border-dashed px-24 py-12 font-bold">
  //         USE CODE: <span className="text-primary">BESTSALE</span>
  //       </div>
  //     </div>
  //   ) : (
  //     <div className="desktop:flex-row tablet:gap-24 flex flex-col items-center justify-center gap-10">
  //       <Image
  //         alt="+ Extra 20%*"
  //         className="desktop:hidden w-3/5"
  //         height="58"
  //         lazyload={false}
  //         src={require("images/layout/extra-20-off-mobile.svg")}
  //         width="347"
  //       />
  //       <Image
  //         alt="+ Extra 20% Off*"
  //         className="desktop:block w-288 large:w-auto hidden"
  //         height="58"
  //         lazyload={false}
  //         src={require("images/layout/extra-20-off-desktop.svg")}
  //         width="450"
  //       />
  //       <div className="tablet:text-28 text-18 large:px-32 large:py-16 border-2 border-dashed border-white px-24 py-12 font-bold">
  //         USE CODE: <span className="text-spotlight">BESTSALE</span>
  //       </div>
  //     </div>
  //   )
  // } else if (text.text === "terms") {
  //   return (
  //     <Button
  //       className={cn(
  //         "text-16 font-medium",
  //         sl.config.sale_key.includes("cyber-monday")
  //           ? "text-black-print"
  //           : "text-white"
  //       )}
  //       onClick={() => openModal("#best-sale-terms")}
  //       text
  //       underline
  //     >
  //       *Terms & Conditions Apply.
  //     </Button>
  //   )
  // }

  return text.text
}

CodeRef.propTypes = {
  text: PropTypes.object,
}

export default CodeRef
